import { render, staticRenderFns } from "./DataTableHedge.vue?vue&type=template&id=41c82563&"
import script from "./DataTableHedge.vue?vue&type=script&lang=js&"
export * from "./DataTableHedge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports